// 推荐产品
document.addEventListener("DOMContentLoaded", function() {
  $(document).on("click", "#fbt-show-btn", function() {
    if($(".tw-purchase-together").length) {
        $(".horizontal-product-list").toggleClass("active");
    }
  });
});

// manual-video.liquid
$(function(){
    
    $(".video-pop-wrapper").on("click", ".close-js, .tw-mask", function(e) {
        $(this).closest(".video-pop-wrapper").fadeOut();
        // 暂停视频（包括iframe）
        var videoElement = $(this).closest(".video-pop-wrapper").find("video")[0];
        if (videoElement) {
          videoElement.pause();
        }
        var iframeElement = $(this).closest(".video-pop-wrapper").find("iframe")[0];
        if (iframeElement) {
          var iframeSrc = iframeElement.src;
          iframeElement.src = iframeSrc; // 重新设置iframe的src将其暂停
        }
    });

    $('.video-pop-js').click(function(e) {
        const popId = $(this).attr('pop-id');
        const videoWrap = $('.video-pop-wrapper[pop-id="' + popId + '"]');
        e.preventDefault();
        videoWrap.fadeIn();
        // 播放视频
        const videoElement = videoWrap.find('video')[0];
        if (videoElement && videoElement.paused) {
          videoElement.play();
        }
      
        const iframeElement = videoWrap.find('iframe')[0];
        if (iframeElement) {
          const iframeSrc = iframeElement.src;
          iframeElement.src = iframeSrc; // 重新设置iframe的src将其播放
        }
    });
})

// code复制js
document.addEventListener('DOMContentLoaded', function () {
 const copyIcons = document.querySelector('.code_right');
  const code_contain = document.querySelector('.code_contain');
  const code_text = document.querySelector('.code_text');

  copyIcons.addEventListener('click', function () {
    const codeContainer = this.closest('.code');
    const textToCopy = codeContainer.querySelector('.code_text').textContent.trim();

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        code_text.style.display = 'block';
        code_contain.style.display = 'none';

        setTimeout(() => {
          code_text.style.display = 'none';
          code_contain.style.display = 'block';
        }, 3000);
      })
      .catch((err) => {});
  });
});

  //paypal弹框
document.addEventListener('DOMContentLoaded', function () {
  const showMaskBtn = document.getElementById('showMaskBtn');
  const maskOverlay = document.getElementById('maskOverlay');
  const closeMaskBtn = document.getElementById('closeMaskBtn');

  showMaskBtn.addEventListener('click', function () {
    maskOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  closeMaskBtn.addEventListener('click', function () {
    maskOverlay.style.display = 'none';
    document.body.style.overflow = 'auto';
  });

  maskOverlay.addEventListener('click', function (event) {
    if (event.target === maskOverlay) {
      maskOverlay.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && maskOverlay.style.display === 'flex') {
      maskOverlay.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });
});



  (function() {
    // 滚动显示效果初始化
    function initRevealOnScroll() {
      const elements = document.querySelectorAll('.reveal-on-scroll');
      if (!elements.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target); // 只触发一次
          }
        });
      }, {
        threshold: 0.3,        // 元素20%进入视口时触发
        rootMargin: '0px 0px -20px 0px' // 微调触发时机
      });

      elements.forEach(el => observer.observe(el));
    }

    // 页面加载后初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRevealOnScroll);
    } else {
      initRevealOnScroll();
    }

    // 如果主题有动态加载内容（如Ajax），可在此重新调用 initRevealOnScroll()
  })();